var sourceUrl;
var documentWidth = $(document).width();
var datePickerMode = localStorage.getItem("datePickerMode")
  ? Number(localStorage.getItem("datePickerMode"))
  : 2;
var isScrollLocked = false;
var touchStartY = 0;
var SCROLLABLE_PANELS_SELECTOR = ".js-travelers, .js-flight-search-list";

function preventBackgroundTouchMove(e) {
  var $scrollable = $(e.target).closest(SCROLLABLE_PANELS_SELECTOR);

  // touch started outside any open panel -> always block (this is what
  // stops the background page from scrolling)
  if (!$scrollable.length) {
    e.preventDefault();
    return;
  }

  // if it has reached its top/bottom edge, prevent the bounce leaking
  var el = $scrollable[0];
  var touchY = e.touches[0].clientY;
  var deltaY = touchY - touchStartY;
  var atTop = el.scrollTop <= 0;
  var atBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;

  if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
    e.preventDefault();
  }
}

function trackTouchStart(e) {
  touchStartY = e.touches[0].clientY;
}

function lockBodyScroll() {
  if (isScrollLocked) return;
  isScrollLocked = true;
  $("html").addClass("no-scroll");
  document.addEventListener("touchstart", trackTouchStart, { passive: true });
  // { passive: false } is required so preventDefault() actually works
  document.addEventListener("touchmove", preventBackgroundTouchMove, {
    passive: false,
  });
}

function unlockBodyScroll() {
  if (!isScrollLocked) return;
  isScrollLocked = false;
  $("html").removeClass("no-scroll");
  document.removeEventListener("touchstart", trackTouchStart, { passive: true });
  document.removeEventListener("touchmove", preventBackgroundTouchMove, {
    passive: false,
  });
}

$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  datePicker();

  // show more description in property
  $(".js-show-more").on("click", function () {
    $(".js-property-footer-content").toggleClass("auto-height");
    $(this).toggleClass("active");
  });

  $(".js-flight-booking-infant-info").click(function () {
    $(this)
      .closest(".js-travelers")
      .find(".js-flight-booking-infant-description")
      .slideDown();
  });

  $(".js-flight .js-auto-search").each(function () {
    autoSearch($(this));
  });

  //tab click
  var flag = 0;

  radioCheckedValue = $(
    ".js-flight .js-routes-select input:radio:checked",
  ).val();

  $(".js-flight-tab").click(function () {
    routesTypeCheck(radioCheckedValue);
  });

  routesTypeCheck(radioCheckedValue);

  ////////////traveller count form

  const passemgers = (target) => {
    return {
      adult: Number(
        $(target)
          .closest(".js-travelers")
          .find(".js-passenger-adult")
          .find(".js-number-passenger")
          .text(),
      ),
      child: Number(
        $(target)
          .closest(".js-travelers")
          .find(".js-passenger-child")
          .find(".js-number-passenger")
          .text(),
      ),
      infant: Number(
        $(target)
          .closest(".js-travelers")
          .find(".js-passenger-infant")
          .find(".js-number-passenger")
          .text(),
      ),
    };
  };

  const updatePassenger = (target, type, value) => {
    $(target).parent().find(".js-number-passenger").text(value);
    $(target)
      .closest(".js-economy-target")
      .find(`.js-flight-${type}-number`)
      .text(value);
    handlePassengerLimitErrorMessage(target);
  };

  const increaseAdult = (target) => {
    let { adult, child } = passemgers(target);

    if (adult + child > 8)
      handlePassengerLimitErrorMessage(target, "maxPassengersNumbers");
    else updatePassenger(target, "adults", adult + 1);
  };

  const increaseChild = (target) => {
    let { adult, child } = passemgers(target);

    if (adult + child > 8)
      handlePassengerLimitErrorMessage(target, "maxPassengersNumbers");
    else updatePassenger(target, "child", child + 1);
  };

  const increaseInfant = (target) => {
    let { adult, infant } = passemgers(target);

    if (adult <= infant)
      handlePassengerLimitErrorMessage(
        target,
        "validationOfAdultAndInfantsNumber",
      );
    else updatePassenger(target, "infant", infant + 1);
  };

  const decreaseAdult = (target) => {
    let { adult, infant } = passemgers(target);

    if (
      adult <=
      Number($(target).parent().find(".js-number-passenger").data("min"))
    )
      handlePassengerLimitErrorMessage(target, "minPassengersNumbers");
    else if (adult <= infant)
      handlePassengerLimitErrorMessage(
        target,
        "validationOfAdultAndBabiesNumber",
      );
    else updatePassenger(target, "adults", adult - 1);
  };

  const decreaseChild = (target) => {
    let { child } = passemgers(target);

    if (
      child >
      Number($(target).parent().find(".js-number-passenger").data("min"))
    )
      updatePassenger(target, "child", child - 1);
  };

  const decreaseInfant = (target) => {
    let { infant } = passemgers(target);

    if (
      infant >
      Number($(target).parent().find(".js-number-passenger").data("min"))
    )
      updatePassenger(target, "infant", infant - 1);
  };

  const handlePassengerLimitErrorMessage = (target, msg) => {
    const errorMessages = {
      maxPassengersNumbers:
        "تعداد مسافران غیر از نوزاد بیشتر از ۹ نفر نمیتواند باشد",
      validationOfAdultAndInfantsNumber:
        "تعداد نوزاد نمی تواند بیشتر از تعداد بزرگسال باشد",
      minPassengersNumbers: "حداقل تعداد مسافران یک بزرگسال می باشد",
      validationOfAdultAndBabiesNumber:
        "تعداد بزرگسال نمی تواند کمتر از تعداد نوزاد باشد",
    };

    // for desktop
    let errorLocation = $(target)
      .closest(".js-booking-section.active")
      .find(".js-flight .js-section-active .js-travelers");

    if (errorLocation.find(".js-error-travelers").length)
      errorLocation.find(".js-error-travelers").text(errorMessages[msg] || "");
    else
      errorLocation.append(
        `<small class="text-red hide-in-not-desktop js-error-travelers">${
          errorMessages[msg] || ""
        }</small>`,
      );

    // for mobile
    $(target)
      .closest(".js-travelers")
      .find(".js-validation-economy")
      .text(errorMessages[msg] || "");
  };

  const findPassengerType = (target) => {
    let listElementClass = $(target).closest("li").attr("class");

    return listElementClass.includes("js-passenger-adult")
      ? "adult"
      : listElementClass.includes("js-passenger-child")
      ? "child"
      : listElementClass.includes("js-passenger-infant")
      ? "infant"
      : undefined;
  };

  var sum;
  // increase passengers
  $(".js-flight .js-count-box .js-max").click(async function () {
    let actions = {
      adult: increaseAdult,
      child: increaseChild,
      infant: increaseInfant,
    };

    if (actions[findPassengerType($(this))])
      await actions[findPassengerType($(this))]($(this));

    calcSum($(this).closest(".js-economy-target"));
  });

  // decrease passengers
  $(".js-flight .js-count-box .js-min").click(async function () {
    let actions = {
      adult: decreaseAdult,
      child: decreaseChild,
      infant: decreaseInfant,
    };

    if (actions[findPassengerType($(this))])
      await actions[findPassengerType($(this))]($(this));

    calcSum($(this).closest(".js-booking-container"));
  });

  $(".js-flight .js-economy-target").each(function () {
    calcSum($(this));
  });

  function calcSum(obj) {
    sum = 0;
    obj.find("li.js-passenger-list .js-number-passenger").each(function () {
      sum += Number($(this).text());
      obj.find(".js-traveles-number .js-number").text(sum);
    });
  }

  //select cabin type
  $(".js-flight .js-cabin-type").change(function () {
    $(".js-cabin-type-label").text(this.value).attr("title", $(this).val());
  });

  //route type select
  var radioCheckedValue = $(
    '.js-flight input:radio[name*="routeType"]:checked',
  ).val();

  $(".js-routes-select").on("change", "input", function () {
    routesTypeCheck($(this).val(), $(this));
  });

  function routesTypeCheck(value, obj) {
    if (value === "twoWay") {
      $(obj)
        .closest(".js-booking-section.active")
        .find(".js-flight")
        .find(".returnDate")
        .show();

      $(".js-one-or-two-route-container").show().addClass("js-section-active");

      $(".js-serveral-routes-container").hide();

      $(".js-flight-departure").addClass("two-calendar");

      sum = $(
        ".js-booking-section.active .js-one-or-two-route-passengers-sum",
      ).text();
    } else if (value === "oneWay") {
      sum = $(
        ".js-booking-section.active .js-one-or-two-route-passengers-sum",
      ).text();

      // $(".js-booking-section.active .js-flight .returnDate").hide();

      $(obj)
        .closest(".js-booking-section.active")
        .find(".js-flight")
        .find(".returnDate")
        .hide();

      $(".js-flight-departure").removeClass("two-calendar");

      $(".js-one-or-two-route-container").show().addClass("js-section-active");

      $(".js-serveral-routes-container")
        .hide()
        .removeClass("js-section-active");
    } else if (value === "severalWay") {
      sum = $(
        ".js-booking-section.active .js-serveral-routes-passengers-sum",
      ).text();

      $(".js-one-or-two-route-container")
        .hide()
        .removeClass("js-section-active");

      $(".js-flight-departure").removeClass("two-calendar");

      $(".js-serveral-routes-container").show().addClass("js-section-active");
    }
  }

  function flightPassengerLimit({ adult, child, infant }, target) {
    // target: HTMLElement, adult: number, child: number, infant: number
    let msg = "";
    if (+adult < 1) msg = "تعداد مسافر بزرگسال باید حداقل یک نفر باشد";
    if (+adult + +child > 9) {
      msg = "تعداد مسافران غیر از نوزاد بیشتر از ۹ نفر نباید باشد";
    }
    if (+infant > +adult) {
      msg = `نوزادان همیشه با والدین یا سرپرستان خود سفر میکنند (هر بزرگسال یک کودک)، ${msg}`;
    }

    if (msg && $(window).width() > 767) {
      let errorLocation = $(target)
        .closest(".js-booking-section.active")
        .find(".js-flight .js-section-active .js-travelers");

      if (errorLocation.find(".js-error-travelers").length)
        errorLocation.find(".js-error-travelers").text(msg);
      else
        errorLocation.append(
          `<small class="text-red hide-in-not-desktop js-error-travelers">${msg}</small>`,
        );

      $(target)
        .closest(".js-booking-section.active")
        .find(".js-flight .js-section-active .js-economy-target>button")
        .next(".js-travelers")
        .fadeToggle();
    }

    return msg;
  }

  ////search btn
  $(".js-flight button.js-flight-search").click(function (e) {
    var localStorageKey = `${window.prefixSearchHistory}-${
      $(".js-search-holder-landing").attr("id") ||
      $(this)
        .closest(".js-tab-nav")
        .find(".js-tab-content>div.active")
        .attr("id")
    }`;
    var searchHistoryItem = {
      value: {},
      baseUrl: "",
      expire: "",
    };

    $(this)
      .closest(".js-booking-section.active")
      .find(".js-flight")
      .find(".error-message")
      .remove();
    var valid = true;
    var routeValid = true;
    var message = "";

    var baseUrl = "/" + "fa" + "/flight/";
    var cabinTypeNumber = "";
    if ($(".js-tab-nav").length) {
      $(".js-tab-nav").find(".js-flight-tab.active").attr("data-searchType") ==
      "external-flight"
        ? 3 // international flight
        : ""; //internal flight;
    } else {
      cabinTypeNumber =
        $(this).closest(".js-booking-section.active").attr("data-searchType") ==
        "external-flight"
          ? 3 // international flight
          : ""; //internal flight;
    }

    //external
    var routeType = $(this)
      .closest(".js-booking-section.active")
      .find(".js-flight")
      .find(".js-routes-select input:checked")
      .val(); // oneWay | twoWay | severalWay
    searchHistoryItem.value.routeType = routeType;

    var cabinType = $(this)
      .closest(".js-booking-section.active")
      .find(".js-flight")
      .find(".js-cabin-type-label")
      .attr("title"); // First | Business | Economy | Premium | <empty string>
    searchHistoryItem.value.cabinType = cabinType;

    switch (cabinType) {
      case "First":
        cabinTypeNumber = 1;
        break;

      case "Business":
        cabinTypeNumber = 2;
        break;

      case "Economy":
        cabinTypeNumber = 3;
        break;

      case "Premium":
        cabinTypeNumber = 4;
        break;

      case "PremiumEconomy":
        cabinTypeNumber = 16;
        break;

      case "Comfort":
        cabinTypeNumber = 32;
        break;

      case "EconomyPlus":
        cabinTypeNumber = 64;
        break;

      case "BusinessPremium":
        cabinTypeNumber = 128;
        break;
    }

    searchHistoryItem.value.cabinTypeNumber = cabinTypeNumber;

    if ($(".js-tab-nav").length) {
      baseUrl +=
        $(".js-tab-nav")
          .find(".js-flight-tab.active")
          .attr("data-searchType") == "external-flight"
          ? "int/" // international flight
          : "dom/"; //internal flight
    } else {
      baseUrl +=
        $(this).closest(".js-booking-section.active").attr("data-searchType") ==
        "external-flight"
          ? "int/"
          : "dom/";
    }

    if (routeType !== "severalWay") {
      // oneWay or twoWay
      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-from-city")
          .data("code")
      ) {
        // from-city
        let fromCity = $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-from-city")
          .data();

        baseUrl += fromCity.code + "-";
        searchHistoryItem.value.fromCity = {
          code: fromCity.code,
          value: fromCity.value,
          title: fromCity.title,
        };
      } else {
        valid = false;
      }
      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-to-city")
          .data("code")
      ) {
        // to-city
        let toCity = $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-to-city")
          .data();

        baseUrl += toCity.code;
        searchHistoryItem.value.toCity = {
          code: toCity.code,
          value: toCity.value,
          title: toCity.title,
        };
      } else {
        valid = false;
      }
      baseUrl += "/?Cab=" + cabinTypeNumber + "&";

      var startDateValue = $(this).closest(".js-flight").find(".js-pick-date");

      if (startDateValue.val() && startDateValue.next().val()) {
        // start-date
        baseUrl += "Dep=" + startDateValue.next().val();
        searchHistoryItem.value.startDateValue = startDateValue.next().val();
      } else {
        valid = false;
      }

      //dom flight and rafto bargasht
      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find('.js-routes-select input:radio[name*="routeType"]:checked')
          .val() === "twoWay"
      ) {
        // end date
        var endDateValue = $(this).closest(".js-flight").find(".js-pick-date2");

        if (endDateValue.val() && endDateValue.next().val()) {
          baseUrl += "&Ret=" + endDateValue.next().val();
          searchHistoryItem.value.endDateValue = endDateValue.next().val();
        } else {
          valid = false;
        }
      }

      baseUrl +=
        "&Adt=" +
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-adult .js-number-passenger")
          .text();

      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-child .js-number-passenger")
          .text() > 0
      ) {
        baseUrl +=
          "&Chd=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-flight")
            .find(".js-section-active .js-passenger-child .js-number-passenger")
            .text();
      }
      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-infant .js-number-passenger")
          .text() > 0
      ) {
        baseUrl +=
          "&Inf=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-flight")
            .find(
              ".js-section-active .js-passenger-infant .js-number-passenger",
            )
            .text();
      }

      searchHistoryItem.value.passenger = {
        adult: $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-adult .js-number-passenger")
          .text(),
        child: $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-child .js-number-passenger")
          .text(),
        infant: $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-infant .js-number-passenger")
          .text(),
      };

      if (searchHistoryItem.value.fromCity?.code)
        routeValid =
          searchHistoryItem.value.fromCity?.code?.trim()?.toLowerCase() !==
          searchHistoryItem.value.toCity?.code?.trim()?.toLowerCase();
    } else if (routeType === "severalWay") {
      searchHistoryItem.value.trip = [];
      $(this)
        .closest(".js-booking-section.active")
        .find(".js-flight")
        .find(".js-serveral-routes-container .js-auto-search")
        .each(function (index, value) {
          if ($(this).val() !== "") {
            searchHistoryItem.value.trip.push({
              code: $(this).data("code"),
              value: $(this).data("value"),
            });
            var valThis = $(this).data("code");
            baseUrl += valThis;

            if (
              $(".js-serveral-routes-container .js-auto-search").length - 1 !=
              index
            ) {
              baseUrl += "-";
            }
          } else {
            valid = false;
          }
        });

      baseUrl += "/?Cab=" + cabinTypeNumber + "&";

      searchHistoryItem.value.date = [];
      $(this)
        .closest(".js-booking-section.active")
        .find(".js-flight")
        .find(".js-section-active .js-pick-date")
        .each(function (index, value) {
          if ($(this).val() !== "") {
            baseUrl += "Dep=" + $(this).next().val() + "&";
            searchHistoryItem.value.date.push($(this).next().val());
          } else {
            valid = false;
          }
        });

      baseUrl +=
        "Adt=" +
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-adult .js-number-passenger")
          .text();

      if (
        Number(
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-flight")
            .find(".js-section-active .js-passenger-child .js-number-passenger")
            .text(),
        ) > 0
      ) {
        baseUrl +=
          "&Chd=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-flight")
            .find(".js-section-active .js-passenger-child .js-number-passenger")
            .text();
      }
      if (
        Number(
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-flight")
            .find(
              ".js-section-active .js-passenger-infant .js-number-passenger",
            )
            .text(),
        ) > 0
      ) {
        baseUrl +=
          "&Inf=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-flight")
            .find(
              ".js-section-active .js-passenger-infant .js-number-passenger",
            )
            .text();
      }

      searchHistoryItem.value.passenger = {
        adult: $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-adult .js-number-passenger")
          .text(),
        child: $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-child .js-number-passenger")
          .text(),
        infant: $(this)
          .closest(".js-booking-section.active")
          .find(".js-flight")
          .find(".js-section-active .js-passenger-infant .js-number-passenger")
          .text(),
      };

      routeValid = !searchHistoryItem.value.trip.some(
        (tripItem, i, arr) =>
          i % 2 === 0 && tripItem?.code && tripItem?.code === arr[i + 1]?.code,
      );
    }

    message = flightPassengerLimit(searchHistoryItem.value.passenger, $(this));

    if (!valid || !routeValid || message) {
      let msg = [];
      if (!valid) msg.push("لطفا تمام فیلدها را کامل نمایید");
      if (!routeValid) msg.push("مبدا و مقصد نمی تواند یکسان باشد");
      if (message) msg.push(message);
      $(this)
        .closest(".js-booking-section.active")
        .find(".js-flight")
        .append(`<span class='error-message'>${msg.join("، ")}</span>`);
      return false;
    } else {
      searchHistoryItem = {
        ...searchHistoryItem,
        baseUrl: baseUrl,
        expire: !!startDateValue
          ? startDateValue.next().val()
          : searchHistoryItem.value.date[0],
      };
      window.updateLocalStorage(localStorageKey, searchHistoryItem);

      window.location.assign(baseUrl);
    }
  });

  //////////
  $(".js-exchange-btn").click(function () {
    var input1 = $(this).closest(".js-flight-cities").find(".js-from-city");
    var input2 = $(this).closest(".js-flight-cities").find(".js-to-city");
    if (!input1.data("code") || !input2.data("code")) return;
    var inputList1 = input1
      .closest(".js-flight-city")
      .find(".js-flight-search-list");
    var inputList2 = input2
      .closest(".js-flight-city")
      .find(".js-flight-search-list");

    var valueHolderInMobile1 = $(this)
      .closest(".js-flight-cities")
      .find(".js-from-city")
      .siblings(".js-input-layout");
    var valueHolderInMobile2 = $(this)
      .closest(".js-flight-cities")
      .find(".js-to-city")
      .siblings(".js-input-layout");

    $(input2).swap(input1);

    $(valueHolderInMobile2).swap(valueHolderInMobile1);

    $(inputList2).swap(inputList1);

    input1.removeClass("js-from-city").addClass("js-to-city");
    input2.removeClass("js-to-city").addClass("js-from-city");
  });
  //swap elements
  $.fn.swap = function (elem) {
    elem = elem.jquery ? elem : $(elem);
    return this.each(function () {
      $(document.createTextNode(""))
        .insertBefore(this)
        .before(elem.before(this))
        .remove();
    });
  };
  //traveller menu close
  // FIX: mobile branch now removes the SAME class the open handler adds
  // ("show-mobile"). It previously removed "show-tmenu", a class that
  // was never added anywhere, so outside clicks never closed the panel
  // on mobile and never released the scroll lock either.
  $(document).mouseup(function (e) {
    if (
      !$(".js-economy-target").is(e.target) && // if the target of the click isn't the container...
      $(".js-economy-target").has(e.target).length === 0
    ) {
      if ($(window).width() > 767) {
        // ... nor a descendant of the container
        $(".js-travelers").fadeOut();
      } else {
        $(".js-travelers").removeClass("show-mobile");
        unlockBodyScroll();
      }
    }
  });

  ///events control in mobile
  $(".js-flight").delegate(".js-close-auto-complete", "click", function () {
    $("input#js-from-city, input#js-to-city").autocomplete("close");
    $(".js-flight-city").removeClass("show-mobile");
    $(".js-flight-search-list>ul").hide();
    unlockBodyScroll();
  });
});

function GetLanguage() {
  return window.location.pathname.split("/")[1];
}

//add flight in several rout
$(document).delegate(".js-add-flight-route", "click", function () {
  if ($(".js-routes-row").length <= 5) {
    var toCityValue = $(".js-routes-row").last().find(".js-to-city").val();
    var toCityValueAttr = $(".js-routes-row")
      .last()
      .find(".js-to-city")
      .attr("data-code");
    var toCitydirection = $(".js-routes-row")
      .last()
      .find(".js-to-city")
      .css("direction");

    var language = GetLanguage();

    var routeRowTemplate = `
    <div class="flight-booking-inner js-routes-row js-added-flight">
<div class="flight-booking-inner-title">
  <label class="js-route-number hide-in-desktop"></label>
  <button class="flight-booking__remove js-delete-flight-route">
  <i class="icon-close-circle"></i>
  </button>
</div>

    <div class="flight-booking__item flight-booking__item--city js-flight-cities p--0" data-searchType="external-flight">
        <div class="flight-booking__item flight-booking__item--from flight-booking__city-item js-flight-city">
            <div class="flight-booking__city-item-inner">
                <div>
                <div class="flight-booking__item-input-title hide-in-desktop">
                                                                                    <label class="hide-in-desktop">از</label>
                                                                                    <button class="js-close-auto-complete">
                                                                                        <i class="icon-close"></i>
                                                                                    </button>
                                                                                </div>
                    <div class="form-element-group form-element-group--with-icon">
                    
                        <div>
                        <div class="search-input-layout-in-mobile js-input-layout"></div>
                            <input type="text" data-hj-whitelist id="js-from-city" autocomplete="off" class="js-auto-search js-from-city" placeholder='از' />
                            <div class="flight-booking__list js-flight-search-list"></div>
                            <i class="icon-plane-line"></i>
                        </div>
                    </div>
                    <div class="flight-booking__item-loader js-search-loading">کمی صبر کنید</div>
                </div>

                <button class="flight-booking__exchange btn btn--light js-exchange-btn">
                    <i class="icon-exchange"></i>
                </button>
            </div>
        </div>

        <div class="flight-booking__item flight-booking__item--none-border flight-booking__city-item js-flight-city flight-booking__item--to">
            <div class="flight-booking__city-item-inner">
                <div>
                    <div class="flight-booking__item-input-title">
                        <label class="hide-in-desktop">به</label>
                        <button class="js-close-auto-complete">
                            <i class="icon-close"></i>
                        </button>
                    </div>
                    <div class="form-element-group">
              
                        <div>
                        <div class="search-input-layout-in-mobile js-input-layout"></div>
                            <input type="text" data-hj-whitelist id="js-to-city" autocomplete="off" class="js-auto-search js-to-city" placeholder='به' />
                            <div class="flight-booking__list js-flight-search-list"></div>
                            <i class="icon-flight-land"></i>
                        </div>
                    </div>
                    <div class="flight-booking__item-loader js-search-loading">کمی صبر کنید ...</div>
                </div>
            </div>
        </div>
    </div>

    <div class="flight-booking__item flight-booking__item--departure rangeDates p--0">
        <div class="flight-booking__departure js-flight-departure">
            <div>                
                <div class="form-element-group form-element-group--with-icon">
                  <div>
                      <input type="text" data-hj-whitelist readonly class="js-pick-date pickDate" placeholder="تاریخ" />
                      <input type="hidden" />
                      <i class="icon-calendar"></i>
                  </div>
                </div>
            </div>
        </div>
    </div>
  
</div>
    `;
    $(".js-routes-row").last().after($(routeRowTemplate));
    for (var i = 0; i < $(".js-route-number").length; i++) {
      var item = $(".js-route-number")[i];
      $(item).text(`مسیر ${i + 1}`);
    }

    srcType = $(this).attr("data-searchType");

    getUrl(srcType);

    setTimeout(function () {
      $(".js-flight .js-auto-search").each(function () {
        autoSearch($(this));
      });
    }, 100);

    newdatePicker();
  }
});

//delete flight
$(document).delegate(".js-delete-flight-route", "click", function () {
  $(this).closest(".js-added-flight").remove();
  for (var i = 0; i < $(".js-route-number").length; i++) {
    var item = $(".js-route-number")[i];
    $(item).text(`مسیر ${i + 1}`);
  }
});

//delete all flight
$(document).delegate(".js-clear-all-flight", "click", function () {
  $(".js-added-flight").remove();
  for (var i = 0; i < $(".js-route-number").length; i++) {
    var item = $(".js-route-number")[i];
    $(item).text(`مسیر ${i + 1}`);
  }
});

//economy click
// FIX: e.stopPropagation() so this click doesn't bubble up to the
// document-level "close" handler above and immediately close the panel
// again; and use lockBodyScroll() for a real, iOS-safe scroll lock.
$(document).delegate(".js-economy-target>button", "click", function (e) {
  e.stopPropagation();
  $(this).next(".js-travelers").fadeToggle();
  $(this).next(".js-travelers").toggleClass("show-mobile");
  if (documentWidth < 992) {
    lockBodyScroll();
  }
});

//remove input text
$(document).delegate(".js-close-tmenu", "click", function () {
  $(this).closest(".js-travelers").hide();
  unlockBodyScroll();
});

// sort arrayObject
function sortArrayObject(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    var comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}

var cityList = [];

//autoComplete
function autoSearch($this) {
  if ($($this).closest(".js-flight-cities").length) {
    if (
      $(".js-booking-section.active").attr("data-searchType") ===
      "internal-flight"
    ) {
      if (typeof internalCityList != "undefined") {
        cityList = internalCityList;
      }
    } else {
      if (typeof internalCityList != "undefined") {
        cityList = externalCityList;
      }
    }
  }

  $(".js-tab-nav .js-tab-nav-header button").on("click", function () {
    setTimeout(function () {
      if (
        $(".js-tab-nav").find("li.active").attr("data-searchType") ===
        "internal-flight"
      ) {
        if (typeof internalCityList != "undefined") {
          cityList = internalCityList;
        }
      } else {
        if (typeof internalCityList != "undefined") {
          cityList = externalCityList;
        }
      }
    }, 0);
  });

  $.widget("custom.autocomplete", $.ui.autocomplete, {
    _renderMenu: function (ul, items) {
      var that = this,
        currentCategory = "";
      var sortedByFeatured = items.sort(sortArrayObject("isFeatured", "desc"));
      $.each(sortedByFeatured, function (index, item) {
        if (Object.keys(item).length) {
          that._renderItemData(ul, item);
        }
      });

      if (ul.find(".autocomplete-category-title").length === 1) {
        ul.find(".autocomplete-category-title").remove();
      }
    },

    _renderItem: function (ul, item) {
      var li = "";

      if (Object.keys(item).length) {
        var className = item.isRtl ? "rtl" : "ltr";
        ul.removeClass("rtl ltr");
        ul.addClass(className);

        if (!item.hasOwnProperty("airport") && item.label) {
          li +=
            '<li><span class="item-wrapper">' +
            '<i class="icon-map"></i><div><span class="city-title">' +
            item.label +
            "</span>";

          if (item.hasOwnProperty("airports") && item.airports !== null) {
            li += '<strong class="sub-title">همه فرودگاه ها</strong>';
          } else if (
            item.hasOwnProperty("airports") &&
            item.airports === null
          ) {
            li +=
              '<strong class="sub-title"> (' +
              item.code.toUpperCase() +
              ")</strong>";
          }

          li += "</span></div></li>";
        } else if (
          item.hasOwnProperty("airport") &&
          item.requestTerm != "" &&
          item.airport
        ) {
          var subdirectoryIcon = '<i class="icon-enter"></i>';
          li +=
            '<li class="airports"><div><span class="item-wrapper">' +
            subdirectoryIcon +
            '<span class="city-title"> <i class="icon-plane"></i>' +
            item.label +
            "</span>";
          li += "</span></div></li>";
        }
      }

      return $(li).appendTo(ul);
    },
  });

  $this
    .autocomplete({
      minLength: 0,
      delay: 400,
      appendTo: $this.next(),
      search: function (event) {
        $this.closest(".js-flight-city").find(".js-search-loading").show();
        if (
          $this.is(".js-to-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
            "internal-flight"
        ) {
          cityList =
            typeof destinationInternalCityList != "undefined"
              ? destinationInternalCityList
              : internalCityList;
        }
        if (
          $this.is(".js-to-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
            "external-flight"
        ) {
          cityList =
            typeof destinationExternalCityList != "undefined"
              ? destinationExternalCityList
              : externalCityList;
        }
        if (
          $this.is(".js-from-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
            "internal-flight"
        ) {
          cityList = internalCityList;
        }
        if (
          $this.is(".js-from-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
            "external-flight"
        ) {
          cityList = externalCityList;
        }

        $(this).closest(".js-flight-city").addClass("show-mobile");

        if (documentWidth < 992) {
          lockBodyScroll();
        }
        $(this).parent().find(".error-message").remove();
      },
      source: function (request, response) {
        if ($this.val() && cityList != null) {
          var srcType = $this
            .closest(".js-flight-cities")
            .attr("data-searchType");

          getUrl(srcType);
          $this.closest(".js-flight-city").find(".js-search-loading").show();
          $.ajax({
            url: sourceUrl,
            data: {
              keyword: request.term,
              orginPlace: $($this).is(".js-from-city"),
            },

            dataType: "json",
            success: function (data) {
              $this
                .closest(".js-flight-city")
                .find(".js-search-loading")
                .hide();
              //flight
              if ($($this).closest(".js-flight-cities").length) {
                var flightsArr = [],
                  cities = {},
                  airports = {};
                response(
                  (flightsArr = []),
                  $.map(data.results, function (obj) {
                    cities = {
                      label: obj.label,
                      value: obj.cityTitle + "(" + obj.code + ")",
                      code: obj.code,
                      cityTitle: obj.cityTitle,
                      airports: obj.airports,
                      isRtl: data.isRtl,
                      isFeatured: obj.isFeatured,
                      requestTerm: request.term,
                    };
                    flightsArr.push(cities);

                    if (obj.airports != null && obj.airports.length) {
                      $.map(obj.airports, function (airport) {
                        airports = {
                          airport: true,
                          label: airport.label,
                          code: airport.code,
                          value: airport.label,
                          isRtl: data.isRtl,
                          isFeatured: obj.isFeatured,
                          cityTitle: airport.cityTitle,
                          requestTerm: request.term,
                        };
                        flightsArr.push(airports);
                      });
                    }

                    return [
                      cities,
                      flightsArr.filter((a) => a.airport === true),
                    ];
                  }),
                );
              }
            },
            error: function () {
              $this
                .closest(".js-flight-city")
                .find(".js-search-loading")
                .hide();
            },
          });
        } else {
          $this.closest(".js-flight-city").find(".js-search-loading").hide();
          if (cityList != null) {
            return response(cityList);
          } else {
            return [];
          }
        }
      },
      open: function () {
        var inputObj = $this;

        inputObj
          .next(".js-flight-search-list")
          .children("ul")
          .width(inputObj.closest(".js-flight-cities").width());
        inputObj
          .next(".js-flight-search-list")
          .children("ul")
          .offset({
            left: inputObj.closest(".js-flight-cities").offset().left,
          });
        if (documentWidth > 992) {
          inputObj
            .closest(".js-flight-cities")
            .find(".js-from-city")
            .addClass("focusedInput");
        }
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");

        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $this.attr("autocomplete", "off");
        }

        inputObj
          .next(".js-flight-search-list")
          .children("ul")
          .css({
            top: "+=" + 12,
          });
      },

      // FIX: this previously stripped "show-mobile" from ALL
      // .js-flight-city elements unconditionally on every close. When
      // selecting the "from" city, the code closes the from-city
      // autocomplete and then immediately re-opens the to-city one - but
      // jQuery UI's "close" event can fire slightly asynchronously, so
      // it was landing AFTER the to-city field had already been
      // re-opened and wiping its "show-mobile" class right back off,
      // making it look like the next field "didn't open". Scoping the
      // removal to just this field's own container fixes it.
      close: function () {
        $(this).closest(".js-flight-city").removeClass("show-mobile");
        unlockBodyScroll();
      },

      select: function (e, ui) {
        $(this).attr("data-code", ui.item.code);
        $(this).attr("data-title", ui.item.cityTitle);
        $(this).attr("data-value", ui.item.value);
        $(this).val();

        $(this).data({
          code: ui.item.code,
          title: ui.item.cityTitle,
          value: ui.item.value,
        });

        $(this).attr("placeholder", ui.item.value);

        $this.parent().find(".error-message").remove();
        $this.removeClass("notValid");

        if (
          $(this).closest(".js-serveral-routes-container").length &&
          $(this).hasClass("js-to-city")
        ) {
          $(this)
            .closest(".js-routes-row")
            .find(".js-pick-date")
            .trigger("focus");

          if ($(this).closest(".js-routes-row").next().length) {
            if (
              !$(this)
                .closest(".js-routes-row")
                .next()
                .find(".js-from-city")
                .val()
            ) {
              if ($(window).width() > 992) {
                $(this).attr("placeholder", ui.item.value);
              }

              $(this).parent().find(".error-message").remove();
            }
          }
        }

        if ($(window).width() <= 992) {
          $(this).closest(".js-flight-city").removeClass("show-mobile");
          $(this)
            .closest(".js-flight-city")
            .find(".js-input-layout")
            .html("<span>" + ui.item.value + "</span>");
          unlockBodyScroll();
          $this.autocomplete("close");
          $this.trigger("blur");
        }

        if ($(this).is(".js-from-city")) {
          $(this)
            .closest(".js-flight-cities")
            .find(".js-to-city")
            .autocomplete("search");

          let timeOut = setTimeout(() => {
            $(this)
              .closest(".js-flight-cities")
              .find(".js-to-city")
              .trigger("focus");
            clearTimeout(timeOut);
          }, 0);
        } else if ($(this).is(".js-to-city")) {
          $(this)
            .closest(".js-one-or-two-route-container")
            .find(".js-pick-date")
            .datepicker("show");
          setTimeout(function () {
            document.activeElement.blur();
            // document.activeElement.focusout()
          }, 0);
        }

        $this.parent().find(".error-message").remove();
        $this.removeClass("notValid");
        $(this).parent().find(".error-message").remove();

        tagManager({ value: ui.item.value, type: searchType });
      },
    })
    .bind("focus", function (event) {
      if (
        $(window).width() > 992 ||
        $(".js-flight-city").hasClass("show-mobile")
      ) {
        $(this).val("");
        $(this).autocomplete("search");
        $this.closest(".js-flight-city").find(".js-search-loading").hide();
      }
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
      $this.closest(".js-flight-city").find(".js-search-loading").hide();
    });
}

//layout in mobile
$(".js-flight").delegate(".js-input-layout", "click", function () {
  $(this).closest(".js-flight-city").addClass("show-mobile");
  $(this).closest(".js-flight-city").find("input").trigger("focus");
  $(this).closest(".js-flight-city").find("input").trigger("search");
});

// init datePicker
function datePicker() {
  setTimeout(function () {
    $(".js-flight .js-flight-departure").pickDate({
      dateFormat: "yy/mm/dd",
      dateFormatEn: "yy M dd",
      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      isDependenceDates: false,
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      customClass: "lightTheme",
      showAllMonthsinList: false,
      langType: datePickerMode === 1 ? "" : "fa",
      blurInmobile: true,
      dayNamesShortFa: [
        "1شنبه",
        "2شنبه",
        "3شنبه",
        "4شنبه",
        "5شنبه",
        "جمعه",
        "شنبه",
      ],
      dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
      enterDateTitle: "تاریخ رفت",
      exitDateTitle: "تاریخ برگشت",
      enterDateTitleEn: "Departure date",
      exitDateTitleEn: "Retun date",
      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },
    });
  }, 100);
}
var ready = false;

function check() {
  if (document.hidden || window.innerWidth > 992) {
    return;
  }

  var form = $(".js-booking-section.active .js-flight").first();
  if (form.length == 0) {
    return;
  }

  var type = form.find(".js-routes-select input:checked").val();
  var from = form.find(".js-from-city").first().data("code");
  var to = form.find(".js-to-city").first().data("code");
  var date1 = form.find(".js-pick-date").first().next().val();
  var date2 = form.find(".js-pick-date2").first().next().val();

  var ok = false;
  if (type != "severalWay" && from && to && date1) {
    ok = true;
  }
  if (type == "twoWay" && !date2) {
    ok = false;
  }

  if (ok && !ready) {
    setTimeout(function () {
      var top = form[0].getBoundingClientRect().top + window.pageYOffset - 8;
      window.scrollTo({ top: top, behavior: "smooth" });
    }, 150);
  }

  ready = ok;
}

setInterval(check, 300);
function newdatePicker() {
  $(".js-routes-row")
    .last()
    .find(".js-flight-departure")
    .pickDate({
      dateFormat: "yy/mm/dd",
      dateFormatEn: "yy M dd",
      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      blurInmobile: true,
      isDependenceDates: false,
      customClass: "lightTheme",
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      maxDate: "+1Y",
      showAllMonthsinList: false,
      langType: datePickerMode === 1 ? "" : "fa",
      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },
    });
}

// get url for ajax
function getUrl(srcType) {
  if (srcType === "internal-flight") {
    sourceUrl = "/airport/iranianairports/";
  } else if (srcType === "external-flight") {
    sourceUrl = "/airport/airports/";
  }
}